<!-- Animated -->
<a class="logo" href="#">
  <img class="logo__image" src="assets/images/logo/gematik.png" alt="Gematik Fachportal" />
  <span class="logo__stripes">
    <span class="logo__stripe stripe-1"></span>
    <span class="logo__stripe stripe-2"></span>
    <span class="logo__stripe stripe-3"></span>
  </span>
</a>
